module.exports = __webpack_public_path__ + "img/locked.c7ecbd82.svg";